
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <div v-if="form.filters.analitico">
                <v-row class="d-flex justify-center mt-3">
                    <v-col cols="4">
                        <v-text-field
                        label="Formação"	
                        v-model="form.filters.formacaoAnalitico"
                        outlined
                        dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-autocomplete
                            v-model="form.filters.origemIdAnalitico"
                            label="Origem da Formação"
                            outlined
                            dense
                            :items="form.lists.origens"
                            item-text="nome"
                            item-value="id"
                        />
                    </v-col>
                    <sigfoco-date-picker
                        :cols="2"
                        label="Data de Solicitação"
                        v-model="form.filters.dataSolicitacaoAnalitico"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                    <sigfoco-date-picker
                        :cols="2"
                        label="Data de Realização"
                        v-model="form.filters.dataRealizacaoAnalitico"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                </v-row>
                <v-row class="d-flex justify-center mt-3">
                    <sigfoco-date-picker
                        :cols="2"
                        label="Data Início"
                        v-model="form.filters.dataInicioAnalitico"
                        removeIcon
                        outlined
                        dense
                  ></sigfoco-date-picker>
                  <sigfoco-date-picker
                    :cols="2"
                    v-model="form.filters.dataFimAnalitico"
                    label="Data Final"
                    removeIcon
                    outlined
                    dense
                  ></sigfoco-date-picker>
                  <sigfoco-switch-button
                    :cols="2"
                    v-model="form.filters.analitico"
                    label="Tipo de Relatório"
                    labelChecked="Analítico"
                    labelUnchecked="Sintético"
                ></sigfoco-switch-button>
                </v-row>
            </div>
            <div v-else>
                <v-row class="d-flex justify-center mt-3">
                    <v-col cols="2">
                        <v-autocomplete
                            v-model="form.filters.tipoFormacaoSintetico"
                            label="Origem da Formação"
                            outlined
                            dense
                            :items="form.lists.origens"
                            item-text="nome"
                            item-value="id"
                        />
                    </v-col>
                    <v-col cols="2">
                        <v-text-field
                        label="Carga Horária Total"	
                        v-model="form.filters.cargaHorariaSintetico"
                        outlined
                        @keypress="$validarEntradaNumerica"
                        inputmode="numeric"
                        dense
                        ></v-text-field>
                    </v-col>
                    <sigfoco-switch-button
                        :cols="2"
                        v-model="form.filters.analitico"
                        label="Tipo de Relatório"
                        labelChecked="Analítico"
                        labelUnchecked="Sintético"
                    ></sigfoco-switch-button>
                </v-row>
                <v-row class="d-flex justify-center mt-3">
                    <sigfoco-date-picker
                        :cols="2"
                        label="Data Início"
                        v-model="form.filters.dataInicioSintetico"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                    <sigfoco-date-picker
                        :cols="2"
                        v-model="form.filters.dataFimSintetico"
                        label="Data Final"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                </v-row>
            </div>
            <div class="text-center">
                <v-col cols="12">
                    <sigfoco-tooltip
                        text="Buscar"
                        icon="mdi-magnify"
                        @click="buscarRelatorios"
                    ></sigfoco-tooltip>
                    <sigfoco-tooltip
                        text="Limpar"
                        icon="mdi-eraser"
                        @click="resetForm"
                    ></sigfoco-tooltip>
                </v-col>
            </div>
        </v-form>
        <v-data-table
          v-if="form.mostrarAnalitico"
          class="mt-5 printable"
          :headers="getFilteredHeader(headersAnalitico)"
          :items="form.lists.listRelatorioAnalitico"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
        >
          <template v-slot:[`item.formacao`]="{ item }">
            {{ item.formacao }}
          </template>
          <template v-slot:[`item.origem`]="{ item }">
            {{ item.origem }}
          </template>
          <template v-slot:[`item.dataSolicitacao`]="{ item }">
            {{ item.dataSolicitacao }}
          </template>
          <template v-slot:[`item.dataRealizacao`]="{ item }">
            {{ item.dataRealizacao }}
          </template>
          <template v-slot:[`item.qtdPrevistas`]="{ item }">
            {{ item.qtdPrevistas }}
          </template>
          <template v-slot:[`item.qtdPresentes`]="{ item }">
            {{ item.qtdPresentes }}
          </template>
          <template v-slot:[`item.dataRealizacao`]="{ item }">
            {{ item.dataRealizacao }}
          </template>
          <template v-slot:[`item.cargaHoraria`]="{ item }">
            {{ item.cargaHoraria }}
          </template>
        </v-data-table>
        <v-data-table
            v-else
            class="mt-5 printable"
            :headers="getFilteredHeader(headersSintetico)"
            :items="form.lists.listRelatorioSintetico"
            :items-per-page="form.itemsPerPage"
            :footer-props="$footerProps"
        >
            <template v-slot:[`item.origem`]="{ item }">
            {{ item.origem }}
            </template>
            <template v-slot:[`item.cargaHoraria`]="{ item }">
            {{ item.cargaHoraria }}
            </template>
            <template v-slot:[`item.qtdFormacoes`]="{ item }">
            {{ item.qtdFormacoes }}
            </template>
            <template v-slot:[`item.qtdPrevistas`]="{ item }">
            {{ item.qtdPrevistas }}
            </template>
            <template v-slot:[`item.qtdPresentes`]="{ item }">
            {{ item.qtdPresentes }}
            </template>
            <template v-slot:[`item.qtdAusentes`]="{ item }">
            {{ item.qtdAusentes }}
            </template>
        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorioAnalitico.length > 0 || form.lists.listRelatorioSintetico.length > 0"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
    import pageLoadingMixin from "mixins/page-loading.mixin";
    import RelatorioSinteticoAnalitico from "services/relatorios-sintetico-analiticos/solicitacao-formacao.service";
    import ManterSetorService from "~/services/manter-setor.service";
    import FormacaoService from "~/services/manter-formacao.service";    
    export default {
        name: "RelatorioSolicitacaoFormacao",
        mixins: [pageLoadingMixin, RelatorioSinteticoAnalitico, ManterSetorService, FormacaoService],
    
        data: () => ({
        onReport: false,
        expanded: [],
        form: {
            filters: {
                analitico: true,
                // analitico
                formacaoAnalitico: null,
                origemIdAnalitico: null,
                dataSolicitacaoAnalitico: null,
                dataRealizacaoAnalitico: null,
                dataInicioAnalitico: null,
                dataFimAnalitico: null,
                // sintetico
                tipoFormacaoSintetico: null,
                dataInicioSintetico: null,
                dataFimSintetico: null,
                cargaHorariaSintetico: null,
            },
            lists: {
                listRelatorios: [],
                listRelatorioAnalitico: [],
                listRelatorioSintetico: [],
                origens: [],
                tiposDeStatus: []
            },
            itemsPerPage: 10,
            geradorRelatorio: null,
            horaDaGeracao: null,
            totalSolicitacaoFormacao: 0,
            mostrarAnalitico: true,
        },
        headersAnalitico: [
            { text: "Formação", align: "center", value: "formacao" },
            { text: "Origem da Formação", align: "center", value: "origem" },
            { text: "Data de Solicitação", align: "center", value: "dataSolicitacao" },
            { text: "Data de Realização", align: "center", value: "dataRealizacao" },
            { text: "Quantidade Prevista de Participantes", align: "center", value: "qtdPrevistas" },
            { text: "Quantidade de Participantes Presentes", align: "center", value: "qtdPresentes" },
            { text: "Carga Horária", align: "center", value: "cargaHoraria" },
        ],
        headersSintetico: [
            { text: "Origem da Formação", align: "center", value: "origem" },
            { text: "Carga Horária Total", align: "center", value: "cargaHoraria" },
            { text: "Quantidade de Formações", align: "center", value: "qtdFormacoes" },
            { text: "Quantidade Prevista de Participantes", align: "center", value: "qtdPrevistas" },
            { text: "Quantidade de Participantes Presentes", align: "center", value: "qtdPresentes" },
            { text: "Quantidade de Participantes Ausentes", align: "center", value: "qtdAusentes" },
        ],
        }),
        watch: {
            "form.filters.analitico"(novoValor) {
                this.form.mostrarAnalitico = novoValor;
                this.resetForm();
            }
        },

        computed: {
            isAnalitico() {
                return this.form.filters.analitico;
            },
        },
        methods: {
        getFilteredHeader(headers) {
            return headers.filter(header => {
            if (header.onlyView) return !this.onReport;
            if (header.onlyReport) return this.onReport;
            return true;
            });
        },
        buscarRelatorios() {
            const isValid = this.validarDatas();
            if (!isValid) return;
            const preparedRequest = this.prepararRequisicao();
                const buscarRelatorio = (request) => {
                return this.$obterRelatorioAnaliticoSolicitacaoFormacao(request);
                };
                buscarRelatorio(this.$montarParamsFilters(preparedRequest)).then(
                ({ data }) => {
                    this.form.mostrarAnalitico = this.isAnalitico;
                    this.form.geradorRelatorio = data.relatorio.geradorRelatorio;
                    this.form.horaDaGeracao = data.relatorio.horaDaGeracao;
                    this.isAnalitico ? 
                    this.form.lists.listRelatorioAnalitico = data.relatorio?.listaAnalitico 
                    : this.form.lists.listRelatorioSintetico = data.relatorio?.listaSintetico; 
                }
            );
        },
        validarDatas() {
            const { dataInicioAnalitico, dataFimAnalitico, dataInicioSintetico, dataFimSintetico } = this.form.filters;
            const msgData = "A Data Início precisa ser anterior ou igual à Data Final";
            if (dataInicioAnalitico && dataFimAnalitico) {
                if (new Date(dataInicioAnalitico) > new Date(dataFimAnalitico)) {
                    this.$notifyWarning(msgData);
                    return false;
                }
            }
            if (dataInicioSintetico && dataFimSintetico) {
                if (new Date(dataInicioSintetico) > new Date(dataFimSintetico)) {
                    this.$notifyWarning(msgData);
                    return false;
                }
            }

            return true;
        },
        async baixarCSVRelatorio() { 
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
                const { data } = await (this.$obterRelatorioAnaliticoCSVSolicitacaoFormacao(this.$montarParamsFilters(preparedRequest))
                );
                this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeSolicitaçãoDeFormação`);
                this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
                this.hidePageLoading();
            }
        },

        async baixarRelatorioPdf() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
                const { data } = await (this.$obterRelatorioAnaliticoPDFSolicitacaoFormacao(this.$montarParamsFilters(preparedRequest))
                );

                const url = URL.createObjectURL(data);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "SIGFOCO.RelatórioDeSolicitaçãoDeFormação.pdf");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
                this.hidePageLoading();
            }
        },

        prepararRequisicao() {
            if (this.isAnalitico) {
            return {
                formacao: this.form.filters.formacaoAnalitico,
                origemId: this.form.filters.origemIdAnalitico,
                dataSolicitacao: this.form.filters.dataSolicitacaoAnalitico,
                dataRealizacao: this.form.filters.dataRealizacaoAnalitico,
                dataInicio: this.form.filters.dataInicioAnalitico,
                dataFim: this.form.filters.dataFimAnalitico,
                isAnalitico: this.isAnalitico,
            };
            } else {
            return {
                origemId: this.form.filters.tipoFormacaoSintetico,
                cargaHorariaTotal: this.form.filters.cargaHorariaSintetico,
                dataInicio: this.form.filters.dataInicioSintetico,
                dataFim: this.form.filters.dataFimSintetico,
                isAnalitico: this.isAnalitico,
            };
            }
        },
        processarRespostaRelatorio(data) {
            this.form.geradorRelatorio = data.relatorio.geradorRelatorio;
            this.form.horaDaGeracao = data.relatorio.horaDaGeracao;
            this.form.length = data.relatorio?.totalSolicitacaoFormacao;
            this.form.lists.listRelatorioAnalitico = data.relatorio?.listaAnalitico;
            this.form.lists.listRelatorioSintetico = data.relatorio?.listaSintetico;
        },

        resetForm() {
          this.form.filters.dataInicioAnalitico = null;
          this.form.filters.dataFimAnalitico = null;
          this.form.filters.dataInicioSintetico = null;
          this.form.filters.dataFimSintetico = null;


    
          this.$nextTick(() => {
            this.$set(this.form.filters, 'dataInicioAnalitico', null);
            this.$set(this.form.filters, 'dataFimAnalitico', null);
            this.$set(this.form.filters, 'dataInicioSintetico', null);
            this.$set(this.form.filters, 'dataFimSintetico', null);
          });
            this.form.filters.formacaoAnalitico = null;
            this.form.filters.origemIdAnalitico = null;
            this.form.filters.dataSolicitacaoAnalitico = null;
            this.form.filters.dataRealizacaoAnalitico = null;
            this.form.filters.tipoFormacaoSintetico = null;
            this.form.filters.cargaHorariaSintetico = null;
            this.form.lists.listRelatorioAnalitico = [];
            this.form.lists.listRelatorioSintetico = [];
        }
    },
    mounted() {
      this.$buscarOrigens().then(({ data }) => {
        this.form.lists.origens = data.itens;
      });
    }
    };
</script>
<style scoped>
.permissoes {
  padding: 1em !important;
  text-align: center;
  font-weight: 500;
}
.permissao {
  padding-right: 0.5em;
}
</style>